import React, { useEffect, useState } from "react";
import TagCloud from "TagCloud";

const About = () => {
  const [size, setSize] = useState(0);
  useEffect(() => {
    function updateSize() {
      setSize(window.innerWidth);
    }
    window.addEventListener("resize", updateSize);
    updateSize();
    return () => window.removeEventListener("resize", updateSize);
  }, []);

  useEffect(() => {
    const Texts = [
      "HTML",
      "CSS",
      "JAVASCRIPT",
      "REACT",
      "PYTHON",
      "Git",
      "NODEJS",
      "C/C++",
      "Firebase",
      "Tailwind",
      "Bootstrap",
      "GraphQL",
    ];

    // console.log(size);
    TagCloud(".tagCloudSphere", Texts, {
      // Sphere radius in px
      radius: size > 769 ? size / 4 - 50 : size / 2 - 10,

      // animation speed
      // slow, normal, fast
      maxSpeed: "normal",
      initSpeed: "normal",

      // Rolling direction [0 (top) , 90 (left), 135 (right-bottom)]
      direction: 135,
    });

    return () => {
      document.querySelector(".tagCloudSphere").children[0].remove();
    };
  }, [size]);

  return (
    <section
      className="flex flex-row flex-wrap justify-between items-center w-11/12 lg:w-9/12"
      id="about"
    >
      <div className="w-full lg:w-2/5">
        <h1 className="my-12 text-4xl text-white">A Little about me!</h1>
        <div className="text-white text-lg">
          <p>
            A passionate web developer who also loves to design. The first
            website that I made was in high school, and since then, I have been
            in love with the whole process. Currently, I am a pre-final year
            student at ABES Engineering College pursuing my bachelor's in
            computer science engineering.
          </p>
          <p className="my-3 italic">
            <strong>My motto is to keep learning and keep developing.</strong>
          </p>
          <p>Also an anime GEEK.</p>
        </div>
      </div>
      <div className="w-full lg:w-2/5 flex justify-center items-center">
        <div className="tagCloudSphere text-yellow-300 text-xl"></div>
      </div>
    </section>
  );
};

export default About;
